
import axios from 'axios';
import AxiosMockAdapter from 'axios-mock-adapter';
import { items } from '@/../json-server/db.json';


function toPathParam(path = '') {
  return typeof path === 'string' ? new RegExp(path.replace(/:\w+/g, '[^/]+')) : path;
}

const mock = new AxiosMockAdapter(axios, { delayResponse: 500 });

mock
  .onGet('/mes-starter-service/items').reply(200, items)
  .onGet(toPathParam('/mes-starter-service/items/:itemNo')).reply(({ url }) => {
    const paths = url.split('/');
    const lastPath = paths[paths.length - 1];

    return [200, items.find((item) => item.itemNo === lastPath)];
  })
  .onAny().passThrough();
